import {
  AppointmentLocation,
  AppointmentType,
  GroupedVisitType,
  KEY,
  VisitType
} from 'store/booking/types';
import { Thunk } from 'store/types';
import { Dispatch } from 'redux';
import * as bookingSelectors from 'store/booking/selectors';

/**
 * Fetch grouped visits to be grouped into one single row for multiple visit types that have the same display title
 * Example: The same provider having both in office visit and video visit
 */
export const GET_GROUPED_VISIT_TYPES = `${KEY}.GET_GROUPED_VISIT_TYPES`;
export const GET_GROUPED_VISIT_TYPES_SUCCESS = `${KEY}.GET_GROUPED_VISIT_TYPES_SUCCESS`;
export const GET_GROUPED_VISIT_TYPES_FAIL = `${KEY}.GET_GROUPED_VISIT_TYPES_FAIL`;

export const getGroupedVisitTypes = (
  patientId: string,
  consumerId: string,
  providerId: string | number,
  birthdate?: string
): Thunk => async (dispatch, getState) => {
  const state = getState();
  const correlationId = bookingSelectors.correlationIDSelector(state);
  return dispatch({
    type: GET_GROUPED_VISIT_TYPES,
    payload: {
      client: 'scheduling',
      request: {
        url: `/visit-types/${providerId}?grouped=true`,
        headers: {
          'x-dfd-consumer-id': consumerId,
          'x-patient-id': patientId,
          birthdate,
          'x-booking-correlation-id': correlationId
        }
      }
    }
  });
};

/**
 * The office/video visitTypes grouped together
 * i.e. General Health Issues or Concerns
 */
export const SET_GROUPED_VISIT_TYPE = `${KEY}.SET_GROUPED_VISIT_TYPE`;
export const CLEAR_GROUPED_VISIT_TYPE = `${KEY}.CLEAR_GROUPED_VISIT_TYPE`;

export const setGroupedVisitType = (groupedVisitType: GroupedVisitType): Thunk => async (
  dispatch: Dispatch
) => {
  dispatch({
    type: SET_GROUPED_VISIT_TYPE,
    payload: groupedVisitType
  });
};

/**
 * The legacy VisitType - visitType within a groupedVisitType
 * i.e. "Office Visit FM" & "Video Office Visit FM"
 */
export const SET_VISIT_TYPE = `${KEY}.SET_VISIT_TYPE`;

export const setVisitType = (visitType: VisitType) => ({
  type: SET_VISIT_TYPE,
  payload: visitType
});

// appointmentType is either 'In Clinic' or 'Video'
export const SET_APPOINTMENT_TYPE = `${KEY}.SET_APPOINTMENT_TYPE`;

export const setAppointmentType = (appointmentType: AppointmentType) => ({
  type: SET_APPOINTMENT_TYPE,
  payload: appointmentType
});

export const SET_APPOINTMENT_LOCATION = `${KEY}.SET_APPOINTMENT_LOCATION`;

export const setAppointmentLocation = (appointmentLocation: AppointmentLocation) => ({
  type: SET_APPOINTMENT_LOCATION,
  payload: appointmentLocation
});

export const SET_APPOINTMENT_DUE_DATE = `${KEY}.SET_APPOINTMENT_DUE_DATE`;

export const setAppointmentDueDate = (dueDate: string) => ({
  type: SET_APPOINTMENT_DUE_DATE,
  payload: dueDate
});

export const CLEAR_APPOINTMENT_LOCATION = `${KEY}.CLEAR_APPOINTMENT_LOCATION`;

export const clearAppointmentLocation = () => ({
  type: CLEAR_APPOINTMENT_LOCATION
});
